import PropTypes from 'prop-types';
import React from 'react';
import './Loader.scss';

class Loader extends React.PureComponent {
  static getSource() {
    // eslint-disable-next-line global-require
    return require('@bibliocommons/images/preloader.grey.gif');
  }

  renderMessage() {
    if (this.props.message) {
      return <div className="loader-message">{this.props.message}</div>;
    }

    return null;
  }

  render() {
    return (
      <div className="cp-loader">
        {this.renderMessage()}
        <img src={Loader.getSource()} alt="Loading" />
      </div>
    );
  }
}

Loader.propTypes = {
  message: PropTypes.node
};

export default Loader;
